// Aufklappbarer Zusatzinhalt („Hinweise anzeigen“, „Werte anzeigen“) – natives <details>, gold beschriftet.
import { useState, type ReactNode } from 'react';
import { CaretRight } from '@phosphor-icons/react';
import { FORM, INNEN } from './form-stil';

export function FormAufklapper({ titel, children }: { titel: string; children: ReactNode }) {
  const [offen, setOffen] = useState(false);
  return (
    <details onToggle={(e) => setOffen(e.currentTarget.open)} className="flex flex-col">
      <summary className="flex cursor-pointer list-none items-center [&::-webkit-details-marker]:hidden"
        style={{ gap: 6, fontSize: 12, fontWeight: 800, color: FORM.gold }}>
        <CaretRight aria-hidden size={11} weight="bold" style={{ transform: offen ? 'rotate(90deg)' : 'none', transition: 'transform .25s' }} />
        {titel}
      </summary>
      <div className="pf-drop pf-scroll overflow-y-auto" style={{
        marginTop: 6, maxHeight: 180, padding: '10px 12px', borderRadius: 12, background: INNEN.aufklapp,
        fontSize: 12, fontWeight: 600, lineHeight: 1.5, color: 'rgba(255,255,255,0.7)',
      }}>
        {children}
      </div>
    </details>
  );
}
